import { GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'
import React, { Dispatch, useEffect, useState } from 'react'
import { TailSpin } from 'react-loading-icons'
import { useDispatch } from 'react-redux'
import { ReCaptcha } from 'src/components/ReCaptcha/ReCaptcha'
import { THEME } from 'src/config/config'
import VendorInvitation from 'src/containers/SignUp/VendorInvitation'
import { validate } from 'src/pages/api/vendor/invitationApi'
import { showToast } from 'src/store/actions/toastAction'

// type Props = {
//   terms: ITermsConditionsEntity
//   privacyPolicy: IPrivacyPolicyEntity
//   newsletterCategories: INewsletterCategoryEntity[]
// }

type company = {
  companyName: string
  companyType: string
  companySize: string
}

const VendorInvitationPage: NextPage = () => {
  const router = useRouter()
  const token = router.query.invitationToken
  const [company, setCompany] = useState<company>({} as company)
  const [validated, setValidated] = useState(false)
  const [registered, setRegistered] = useState(false)
  const [loading, setLoading] = useState(true)
  const [email, setEmail] = useState('' as string)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [jobTitle, setJobTitle] = useState('')

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()

  useEffect(() => {
    if (token !== undefined) {
      validate(token as string)
        .then((res) => {
          if (res.status === 200) {
            setEmail(res.data.email)
            setFirstName(res.data.first_name)
            setLastName(res.data.last_name)
            setJobTitle(res.data.job_title)
            setCompany({
              companyName: res.data.companyName,
              companyType: res.data.companyType,
              companySize: res.data.companySize,
            })
            setValidated(true)
            setRegistered(res.data.registered)
          } else {
            dispatch(showToast('Invitation is invalid. Please sign in', 'error'))
            router.push('/signup-vendor')
          }
        })
        .catch(() => {
          dispatch(showToast('Invitation is invalid. Please sign in', 'error'))
          router.push('/signup-vendor')
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [token])

  return (
    <ReCaptcha>
      {!loading && validated && (
        <VendorInvitation
          email={email}
          token={token as string}
          registered={registered}
          first_name={firstName}
          last_name={lastName}
          job_title={jobTitle}
          company={company}
          // terms={terms}
          // privacyPolicy={privacyPolicy}
        />
      )}

      {loading && (
        <div className="flex h-screen w-full items-center justify-center">
          <TailSpin stroke="#011D58" height="2em" /> <div className="pl-3"> Loading...</div>
        </div>
      )}
    </ReCaptcha>
  )
}

export default VendorInvitationPage

export const getStaticProps: GetStaticProps = async ({}) => {
  if (THEME === 'ilta')
    return {
      revalidate: 60,
      notFound: true,
    }

  // const [{ termsConditions }, { privacyPolicy }, { newsletterCategories }] = await Promise.all([
  //   apolloSdk.getTermsConditions(),
  //   apolloSdk.getPrivacyPolicy(),
  //   apolloSdk.getNewsletterCategories(),
  // ])

  // const termsData = termsConditions?.data
  // const privacyData = privacyPolicy?.data
  // const categoriesData = newsletterCategories?.data

  return {
    props: {},
    revalidate: 60,
  }
}
